import axios from '../index';

export const getTeam = async (signal) => {
  return axios.get(`api/manageteam/`, {
    withCredentials: true,
    signal: signal
  });
};

export const getCallFeature = async (soptype) => {
  return axios.post(`elastic/getsopelasticsearch/`, soptype, {
    withCredentials: true
  });
};

export const updateCallFeature = async (params) => {
  return axios.put(`elastic/sopelasticsearch/`, params, {
    withCredentials: true
  });
};

export const getSopTypes = async (signal) => {
  return axios.get(`api/managesoptypes/`, {
    withCredentials: true,
    signal: signal
  });
};

export const addSalutation = async (params) => {
  return axios.post(`api/managesoptypes/`, params, {
    withCredentials: true
  });
};

export const editSubSop = async (params, sopId) => {
  return axios.put(`api/subsop/${sopId}/`, params, {
    withCredentials: true
  });
};

export const addSubSop = async (params) => {
  return axios.post(`api/subsop/`, params, {
    withCredentials: true
  });
};

export const getCallFeatureList = async (signal) => {
  return axios.get(`api/sopconfiguration/`, {
    withCredentials: true,
    signal: signal
  });
};

//Sop Configuration API's
export const getSopCategory = ({ search, pageSize, pageIndex }) => {
  return axios.get(`api/sop/category/?search=${search}&page=${pageIndex}&page_size=${pageSize}`);
};

export const updateSopCategory = (params) => {
  return axios.put(`api/sop/category/${params.id}/`, params);
};

export const createSopCategory = (params) => {
  return axios.post(`api/sop/category/`, params);
};

export const deleteSopCategory = (id) => {
  return axios.delete(`api/sop/category/${id}/`);
};

export const getSop = ({ search, pageSize, pageIndex, id }) => {
  return axios.get(`api/sop/sop/?category__id=${id}&search=${search}&page=${pageIndex}&page_size=${pageSize}`);
};

export const updateSop = (params) => {
  return axios.put(`api/sop/sop/${params.id}/`, params);
};

export const createSop = (params) => {
  return axios.post(`api/sop/sop/`, params);
};

export const deleteSop = (id) => {
  return axios.delete(`api/sop/sop/${id}/`);
};

export const getAllFeatureTypes = () => {
  return axios.get(`api/sop/feature-type/?get_all=true`);
};

//Sop Parameter API's
export const getSopParams = ({ search, pageSize, pageIndex, id }) => {
  return axios.get(
    `api/sop/feature-type-payload-value/?get_all=true&search=${search}&sop__id=${id}&page=${pageIndex}&page_size=${pageSize}`
  );
};

export const updateSopParams = (params) => {
  return axios.put(`api/sop/feature-type-payload-value/${params.id}/`, params);
};
